import { Col, Form, Input } from 'antd';
import type { IField } from '../data';

const { Item } = Form;

const Text: React.FC<IField> = (props) => {
    const {
        name,
        span = 8,
        label,
        rules,
        hidden,
        placeholder,
        disabled,
        onChange,
        suffix = false,
        suffixWidth,
        readOnly,
        type,
        xs,
        lg,
        marginBottom = 0,
        style,
        prefix,
        tooltip,
        size,
        autoFocus,
        t,
        onInput,
        addonAfter,
    } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item tooltip={tooltip} required={rules?.at(0)?.required} hidden={hidden && hidden} label={t?.(label)}>
                <Item noStyle name={name} rules={rules} {...styling} style={style}>
                    <Input
                        size={size}
                        placeholder={t?.(placeholder)}
                        disabled={disabled}
                        onChange={onChange}
                        style={suffix ? { width: `calc(100% - ${suffixWidth}px)` } : style}
                        readOnly={readOnly}
                        type={type}
                        prefix={prefix}
                        autoFocus={autoFocus}
                        onInput={onInput}
                        addonAfter={addonAfter}
                    />
                </Item>
                {suffix && suffix}
            </Item>
        </Col>
    );
};

export default Text;
